import * as THREE from 'three'

/**
 * A lightweight rounded-box geometry (no three-stdlib dependency). Builds a box
 * whose vertices are pushed outward onto a rounded shell so corners/edges read
 * as beveled — good enough for the embossed diorama tiles, and cheap enough to
 * share a single instance across an InstancedMesh.
 */
export function makeRoundedBox(width: number, height: number, depth: number, radius: number, segments = 3): THREE.BufferGeometry {
  const r = Math.min(radius, width / 2, height / 2, depth / 2)
  const seg = Math.max(1, segments)
  const geo = new THREE.BoxGeometry(width, height, depth, seg, seg, seg)
  const pos = geo.attributes.position as THREE.BufferAttribute
  const hw = width / 2 - r
  const hh = height / 2 - r
  const hd = depth / 2 - r
  const v = new THREE.Vector3()
  const c = new THREE.Vector3()
  for (let i = 0; i < pos.count; i++) {
    v.fromBufferAttribute(pos, i)
    c.set(
      THREE.MathUtils.clamp(v.x, -hw, hw),
      THREE.MathUtils.clamp(v.y, -hh, hh),
      THREE.MathUtils.clamp(v.z, -hd, hd),
    )
    v.sub(c)
    if (v.lengthSq() > 1e-8) v.setLength(r)
    v.add(c)
    pos.setXYZ(i, v.x, v.y, v.z)
  }
  geo.computeVertexNormals()
  return geo
}
